import { locationGoogleMapStyles } from "@insite/content-library/Components/LocationGoogleMap";

Object.assign(locationGoogleMapStyles, {
    googleMap: {
        zoom: 4,
        mapContainerStyle: {
            height: "100%",
            width: "100%",
        },
    },
});
